import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCube4Line = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.6581 2.67661C11.6433 2.10779 12.8577 2.1078 13.8429 2.67664L19.5285 5.95873C20.5138 6.52758 21.121 7.57933 21.121 8.71702V15.2822C21.121 16.4199 20.5138 17.4717 19.5286 18.0405L13.8436 21.3223C12.858 21.8924 11.6429 21.8925 10.6574 21.3223L4.97238 18.0405C3.98714 17.4717 3.37988 16.4199 3.37988 15.2822V8.71702C3.37988 7.57933 3.98708 6.52761 4.97232 5.95876L10.6581 2.67661ZM13.0929 3.97567C12.5718 3.67478 11.9292 3.67478 11.408 3.97567L5.72234 7.25779C5.68408 7.27988 5.64689 7.30335 5.61083 7.32812L12.2501 11.1616L18.8902 7.32816C18.8541 7.30338 18.8169 7.27989 18.7786 7.25779L13.0929 3.97567ZM19.6192 8.63931L13 12.4607V20.0736C13.0311 20.0581 13.0619 20.0416 13.0923 20.024L18.7786 16.7415C19.2997 16.4406 19.621 15.884 19.621 15.2822V8.71702C19.621 8.69102 19.6204 8.66511 19.6192 8.63931ZM11.5 12.4605L4.88168 8.63919C4.88048 8.66504 4.87988 8.69099 4.87988 8.71702V15.2822C4.87988 15.884 5.20117 16.4405 5.72229 16.7414L11.408 20.0236C11.4383 20.0411 11.469 20.0576 11.5 20.0731V12.4605Z",
		fill: "currentColor"
	})
});
export default SvgCube4Line;
